<template>
  <div>
    <div class="sec-head">
      <div>
        <span class="eyebrow">Your people</span>
        <h2>Meet your trainers</h2>
        <p>
          The people guiding you through the course — and who to reach out to
          when you need a hand.
        </p>
      </div>
    </div>
    <div class="tgrid">
      <TrainerCard
        v-for="t in course.trainers"
        :key="t.id"
        :trainer="t"
        @sue="$emit('open-sue')"
      />
    </div>
  </div>
</template>

<script>
import TrainerCard from './TrainerCard.vue'

export default {
  name: 'TrainersSection',
  components: {
    TrainerCard
  },
  props: {
    course: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.sec-head {
  margin-bottom: 18px;
}
.eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--teal-dk);
}
h2 {
  font-size: 1.55rem;
  letter-spacing: -0.01em;
  margin: 4px 0 6px;
}
.sec-head p {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: 0;
}
.tgrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 14px;
}
</style>
